import { DataElement, PaginationParams } from "./common";

export class ClinicsSearchParams {
  clinic?: DataElement;
  clinicId?: string;
  constructor() {}
}

export class Clinic extends DataElement {
  deliveryEmail: string;
  clinicId: string;
  clinicDescr: string;
  deliveryApiSw: boolean;
  addressNotes: string;
  gPlaceId: string;
  gFormattedAddress: string;
  gCity: string;
  gStreetName: string;
  gStreetNumber: string;
  city: string;
  address: string;
  cliShort: string;
  agent?: DataElement;
  delayAlertSw: boolean;
  openFridaySw: boolean;

  constructor(id: string = undefined, text: string = undefined) {
    super(id, text);
    this.clinicId = id;
    this.clinicDescr = text;
  }
}

export class ClinicSearchParams extends PaginationParams {
  clinicId?: string;
  clinic?: Clinic;

  constructor() {
    super();
  }
}
